import { render, staticRenderFns } from "./ImportedGroupsPage.vue?vue&type=template&id=a0b1ce34&scoped=true&"
import script from "./ImportedGroupsPage.vue?vue&type=script&lang=js&"
export * from "./ImportedGroupsPage.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=a0b1ce34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b1ce34",
  null
  
)

export default component.exports